import React, { useState } from 'react';
import { AbstructVar } from '../../components/general/general-component/abstruct-component/AbstructVar';
import InnerLoader from '../../components/general/inner-loader/InnerLoader';

function GeneralSettings({ translate,settings, loadingSettings, handleEdit, isLoading }) {
    let { mode, langLocal } = AbstructVar();

    const [evaluationTime, setEvaluationTime] = useState(settings.other.evaluation_time);
    const [sendScriptLimit, setSendScriptLimit] = useState(settings.other.send_script_limit);

    const handleEvaluationTimeChange = (e) => {
        setEvaluationTime(e.target.value);
    };

    const handleSendScriptLimitChange = (e) => {
        setSendScriptLimit(e.target.value);
    };

    const handleSubmit = (e, settingName) => {
        e.preventDefault();
        const settingValue = settingName === 'evaluation_time' ? evaluationTime : sendScriptLimit;
        handleEdit(settingName, settingValue);
    };

    return (
        <div className='div_setting' id='general-settings'  >
            <h3>{translate('general-settings')}</h3>
            <p>{translate('update-information')}</p>

            {!loadingSettings ? (
                <>
                    <form>
                        <div className='all_div_setting_input'  >
                            <div className='div_setting_input' style={{ padding: "0px 25px" }}>
                                <h3>{translate('evaluation-duration')}</h3>
                                <div className='width_setting'  >
                                    <div className='around_input_setting'>
                                        <input
                                            className={mode === 'dark' ? "darktext" : "lighttext"}
                                            type='number'
                                            id='evaluationTime'
                                            name='evaluation_time'
                                            defaultValue={settings.other.evaluation_time}
                                            onChange={handleEvaluationTimeChange}
                                        />
                                    </div>
                                    <h4>{translate('day')}</h4>
                                </div>
                                <div className='div_input'  >
                                    <button type='submit' onClick={(e) => handleSubmit(e, 'evaluation_time')}>
                                        {
                                            translate('update')
                                        }
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className='all_div_setting_input'  >
                            <div className='div_setting_input' style={{ padding: "0px 25px" }}>
                                <h3>{translate('script-send-limit')}</h3>
                                <div className='width_setting' >
                                    <div className='around_input_setting'>
                                        <input
                                            className={mode === 'dark' ? "darktext" : "lighttext"}
                                            type='number'
                                            id='sendScriptLimit'
                                            name='send_script_limit'
                                            defaultValue={settings.other.send_script_limit}
                                            onChange={handleSendScriptLimitChange}
                                        />
                                    </div>
                                    <h4>{translate('per-day')}</h4>
                                </div>
                                <div className='div_input'>
                                    <button type='submit' onClick={(e) => handleSubmit(e, 'send_script_limit')}>
                                        {
                                            translate('update')
                                        }
                                    </button>
                                </div>
                            </div>
                        </div>

                    </form>
                </>
            ) : (
                <InnerLoader />
            )}
        </div>
    );
}

export default GeneralSettings;
